import { useProfilePreview } from "PFApp/use_profile_preview";
import { Button } from "PFComponents/button";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile } from "PFTypes";

export const UserCell = ({ profile }: { profile: Profile }) => {
  const { showPreview } = useProfilePreview();

  return (
    <Button
      small
      text={getProfileName(profile)}
      kind="text"
      onClick={() => showPreview({ id: profile.id, profile })}
    />
  );
};
